import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { DayOfWeek } from "../instructor-preferences/contracts/DayOfWeek";
import {
  selectInstructorPreferences,
  selectPreferencesInitializationStatus,
} from "../instructor-preferences/instructor-preferences-slice";
import { fetchSchedulePreferences } from "../instructor-preferences/slice-extensions/instructor-preferences-slice-extension";
import { WeekStartDay } from "./utils/calendar-range";

/**
 * The instructor's week-start preference, fetching it on first use. Monday
 * until the preference has loaded.
 */
export const useWeekStartPreference = (): WeekStartDay => {
  const dispatch = useAppDispatch();
  const preferences = useAppSelector(selectInstructorPreferences);
  const preferencesInitStatus = useAppSelector(selectPreferencesInitializationStatus);

  useEffect(() => {
    if (preferencesInitStatus === "not-initialized") {
      dispatch(fetchSchedulePreferences());
    }
  }, [dispatch, preferencesInitStatus]);

  return preferences?.weekStart === DayOfWeek.Sunday ? "Sunday" : "Monday";
};
